<template>
    <div class="custom bg-[#23242A]">
        <div class="flex xl:flex-row flex-col px-4 pt-4 bg-[#23242A] text-white">
            <div class="transition-all duration-100 ease-linear custom-left mr-2" :class="(add || edit || printMenu || mergeProducts)?'xl:w-[40%] w-full':'w-full'">
                <component :is="listType.component" :payload="listType.data" :addedFromBulk="listType.newAdded" :addedData="listType.newAddedData" :resized="add || edit || printMenu || mergeProducts" @closeBulkUpload="closeBulkUpload"
                    @togglePurchaseOrderUploadPopV1="togglePurchaseOrderUploadPopV1" @togglePurchaseOrderUploadPop="togglePurchaseOrderUploadPop" @toggleAddEdit="toggleAddEdit"  @updatedEditItem="updatedEditItem" @openQrCode="openQrCode" @openMergeProducts="openMergeProducts" @openCategorySelect="openCategorySelect" />
            </div>
            <div v-if="add || edit || printMenu || mergeProducts" class="xl:w-[60%] w-full custom-right transition-all duration-100 ease-linear">
                <!-- asn is in item for add-product -->
                <add-product v-if="add" @added="addedRow" :asn="false" :item="editItem" :fulfillment="fulfillment" @toggleAddEdit="toggleAddEdit" @close="closeAdd" />
                <!-- addedRow - added stock from asn upload -->
                <edit-product v-if="edit" :asn="asn" :editItem="editItem" :fulfillment="fulfillment" @added="addedRow" @close="closeEdit" @toggleAddEdit="toggleAddEdit" @updatedEditItem="updatedEditItem" />
                <PrintSelectedCategories v-if="printMenu" @close="closePrintMenu"/>
                <MergeProducts v-if="mergeProducts" :data="categoryData" @close="closeMergeProduct" />
            </div> 
        </div>
        <PurchaseOrderUploadPopV1 v-if="purchaseOrderUploadPopV1" :showTendyUploadV1="showTendyUploadV1" @close="closePurchaseOrderUpload" @uploadedPayload="uploadedPayload" />
        <PurchaseOrderUploadPop v-if="purchaseOrderUploadPop" :showTendyUpload="showTendyUpload" @close="closePurchaseOrderUpload" @uploadedPayload="uploadedPayload" />
        <qr-code-modal v-if="qrcode.modal" :closeCallBack="qrCloseCallBack" :products="categoryData"/>
        <category-modal v-if="category.modal" :data="categoryData" @close="closeCategory" />
       <select-product v-if="exportProductCatalogue" :exportProductSelected="exportProductSelected" @close="closeExportCatalogue" />
    </div>
</template>
<script lang="ts">
import { defineComponent, reactive, ref} from "vue";
import addProduct from '@/views/Products/Product/Add/Add.vue'
import editProduct from '@/views/Products/Product/Edit/Edit.vue'
import QrCodeModal from '@/views/Products/Product/QrCode/Index.vue'
import ProductList from '@/views/Products/Product/List/ProductList.vue'
import PurchaseOrderUploadPopV1 from '@/views/Products/Product/List/OrderUploadPop-v1.vue'
import PurchaseOrderUploadPop from '@/views/Products/Product/List/OrderUploadPop.vue'
// import PurchaseOrderAdd from '@/views/Products/PurchaseOrder/PurchaseOrderAdd/List.vue'  ==> V2
import OrderUploadList from '@/views/Products/Product/List/OrderUploadList.vue'
import PrintSelectedCategories from '@/views/Products/Product/PrintMenu/SelectCategories.vue'
import CategoryModal from '@/views/Products/Product/Category/index.vue'
import MergeProducts from '@/views/Products/Product/Merge/MergeProducts.vue'
import SelectProduct from '@/views/Products/Product/ProductCatalogue/SelectProduct.vue'
import {mapGetters, mapActions, mapMutations} from 'vuex'


export default defineComponent({
    components: {
        addProduct,
        editProduct,
        PurchaseOrderUploadPopV1,
        PurchaseOrderUploadPop,
        QrCodeModal,
        ProductList,
        // PurchaseOrderAdd,    ==> V2
        OrderUploadList,
        PrintSelectedCategories,
        CategoryModal,
        MergeProducts,
        SelectProduct
    },
    setup(){
        // list 
        const listType = ref({
            component: 'ProductList', 
            data: [],
            newAdded: false,
            newAddedData: {},
        })

        // poup
        const purchaseOrderUploadPop = ref(false)
        const purchaseOrderUploadPopV1 = ref(false)

        // add edit
        const add = ref<boolean>(false)
        const edit = ref(false)
        const printMenu = ref(false)
        const mergeProducts = ref(false)
        const exportProductCatalogue = ref(false)
        const exportProductSelected = ref([])
        const asn = <any>ref({})
        const fulfillment = <any>ref(null)
        const editItem = <any>ref({})
        // merge from edit page dropdown
        const category = ref({
            items: [],
            modal: false
        })

        // qrcode
        const qrcode = ref({
          modal: false,
        })

        const categoryData = ref([])
        const showTendyUpload = ref(false)
        const showTendyUploadV1 = ref(false)

        return {listType, purchaseOrderUploadPop, purchaseOrderUploadPopV1, add, edit, printMenu, mergeProducts, exportProductCatalogue, exportProductSelected, asn, fulfillment, editItem, category, qrcode, categoryData, showTendyUploadV1, showTendyUpload}
    },
    mounted(){
        this.add = false
        this.emitter.on("closeAddEdit", this.closeAddEdit);
    },
    beforeDestroy(){
        this.emitter.off("closeAddEdit", this.closeAddEdit);
    },
    computed: {
        ...mapGetters({
            vg_modified: 'modifiedForm/status'
        })
    },
    methods: {
        toggleAddEdit(status){
            this.mergeProducts = false
            this.editItem = status.editItem
            this.asn = status.asn
            this.fulfillment = status.fulfillment
            this.edit = status.edit
            this.add = status.add
            // showPrintMenu 
            this.printMenu = status.printMenu
            this.exportProductCatalogue = status.exportProductCatalogue
            if(status.selectedProducts){
                this.exportProductSelected = status.selectedProducts
            }
        },
        closeAdd(){
            this.add = false
        },
        closeEdit(){
            this.edit = false
        },
        closeAddEdit(){
            if(this.vg_modified){
                this.va_confirmNew({
                        msg: "Leave?",
                        extraMsg:
                            "Are you sure you want to leave? Your changes have not been saved",
                        confirmText: "Yes",
                        confirmClass: "bg-white text-theme-red",
                        cancelText: "No",
                        cancelClass: "bg-theme-green text-white",
                        confirmLeft: true
                }).then(async () => {
                    this.vm_modified(false)
                    this.add = false
                    this.edit = false
                }).catch(err => {
                    console.log(err)
                })
            }else{
                this.add = false
                this.edit = false
            }
            
        },
        closePrintMenu(){
            this.printMenu = false
        },
        closeMergeProduct(){
            this.mergeProducts = false
        },
        addedRow(data){
            // if(this.listType.component=='PurchaseOrderAdd'){  ==> V2
            if(this.listType.component=='OrderUploadList'){
                this.add = false
                this.edit = false
                this.listType.newAdded = true
                this.listType.newAddedData = data
            }else{
                this.add = false
                this.editItem = data
                this.edit = false
                this.listType.newAdded = true
                this.emitter.emit('reloadProductList')
            }
        },
        updatedEditItem(item){
            this.editItem = item
        },
        openQrCode(items){
            this.qrcode.modal = true;
            this.categoryData = items
        },
        openMergeProducts(items){
            this.mergeProducts = true
            this.categoryData = items
        },
        qrCloseCallBack() {
          this.qrcode.modal = false;
          this.emitter.emit('reloadProductList')
        },
        openCategorySelect(items){
            this.category.modal = true
            this.categoryData = items
        },
        closeCategory(){
            this.category.modal = false
        },
        closeExportCatalogue(){
            this.exportProductCatalogue = false
        },
        // purchase order upload
        togglePurchaseOrderUploadPop(status, tendyUpload){
            this.showTendyUpload = tendyUpload
            this.purchaseOrderUploadPop = status
        },
        togglePurchaseOrderUploadPopV1(status, tendyUpload){
            this.showTendyUploadV1 = tendyUpload
            this.purchaseOrderUploadPopV1 = status
        },
        closePurchaseOrderUpload(){
            this.purchaseOrderUploadPop = false
            this.purchaseOrderUploadPopV1 = false
        },
        uploadedPayload(payload){
            this.closePurchaseOrderUpload()
            this.listType = {
                component: 'OrderUploadList',
                // component: 'PurchaseOrderAdd',  ==> V2
                data: payload,
                newAdded: false,
                newAddedData: {}
            }
        },
        closeBulkUpload(){
            this.listType = {
                component: 'ProductList',
                data: [],
                newAdded: false,
                newAddedData: {}
            }
            this.add = false
            this.edit = false
        },
        ...mapMutations({
            vm_modified: 'modifiedForm/mutateStatus'
        }),
        ...mapActions({
            va_confirmNew: 'confirmNew/confirmNew'
        })
    }
})
</script>